import { Link } from 'react-router'

const PlaybookConversationEventGoal = ({ goal, goalId, classifications, playbook, isLeadBotPlaybook }) => {
  const goalName = goal.get('name')
  const classicationId = goal.getIn(['classification', 'classificationId'])
  const classification = classifications.find(c => c.id === classicationId)
  const classificationName = _.get(classification, 'name', '...')
  const goalLink = isLeadBotPlaybook ? `/playbooks/editor/${playbook.id}/visual-builder?allGoalsOpen=true` : `/playbooks/${playbook.id}/edit/goal/${goalId}`
  const goalText = goalName ? goalName : classificationName
  return <Link href={goalLink}>{goalText}</Link>
}

const PlaybookConversationEvent = props => {
  const { loaded, playbook, isAdmin } = props
  if (!loaded) return <span>joined conversation from Playbook</span>

  const playbookName = _.get(playbook, 'name', '...')
  const playbookLink = `/playbooks/${playbook.id}/${isAdmin ? 'edit' : 'report'}`
  return (
    <span>
      joined conversation from Playbook <Link to={playbookLink}>{playbookName}</Link> and Goal {' '}
      <PlaybookConversationEventGoal {...props} />
    </span>
  )
}

export default PlaybookConversationEvent



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/PlaybookConversationEvent/component.js